import {ButtonBorder, Div, Dropdown, ImageView, Label} from 'components';
import {Ecolors, Icons, urlApp} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {getListProduct} from 'reducer/investment';
import {useAppSelector} from 'store/hooks';

import DatePicker, {setDefaultLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import {downloadFile} from 'services';
import {convertTimestamp, joinObjectCalendar} from 'utils';

const days = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
const months = [
  'Tháng 1',
  'Tháng 2',
  'Tháng 3',
  'Tháng 4',
  'Tháng 5',
  'Tháng 6',
  'Tháng 7',
  'Tháng 8',
  'Tháng 9',
  'Tháng 10',
  'Tháng 11',
  'Tháng 12',
];

const locale = {
  localize: {
    day: n => days[n],
    month: n => months[n],
  },
  formatLong: {
    date: () => 'mm/dd/yyyy',
  },
};

function ButtonCalendar(p: {title?: string; onPress: () => void; value?: any}) {
  return (
    <Div
      width={163}
      onPress={() => {
        p.onPress && p.onPress();
      }}
      height={48}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      borderRadius={5}
      borderColor={Ecolors.bordercolor}
      paddingHorizontal={10}
      borderWidth={0.8}>
      <Label
        multilanguage={!p.value}
        size={14}
        // color={p.value ? Ecolors.textColor : Ecolors.grayColor}>
        color={Ecolors.textColor}>
        {!p.value ? p.title : convertTimestamp(p.value.getTime(), '', true)}
      </Label>
      <ImageView
        heightWidth={17}
        source={Icons.calendar}
        resizeMode={'contain'}
      />
    </Div>
  );
}

function Statement(p: {activeTab: number}) {
  const [product, setProduct] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const listProduct = useAppSelector(state => getListProduct(state));
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  const value = useRef<'from' | 'to'>('from');
  const [isShowCalendar, setIsShowCalendar] = useState(false);
  const I18nState = useAppSelector(state => state.languages.I18nState);

  useEffect(() => {
    if (p.activeTab == 3) {
      setDefaultLocale(I18nState);
      clearData();
    }
  }, [p.activeTab]);

  const clearData = () => {
    Promise.all([setProduct(null), setFromDate(null), setToDate(null)]);
  };

  const onAccept = async () => {
    let body = {
      fromDate: '20220807',
      productCode: 'LHBF',
      toDate: '20240813',
    };
    if (toDate) {
      body[`toDate`] = joinObjectCalendar({
        date: toDate.getDate(),
        month: toDate.getMonth(),
        year: toDate.getFullYear(),
        isPicker: true,
      });
    }
    if (fromDate) {
      body[`fromDate`] = joinObjectCalendar({
        date: fromDate.getDate(),
        month: fromDate.getMonth(),
        year: fromDate.getFullYear(),
        isPicker: true,
      });
    }
    if (product) {
      body['productCode'] = product?.code || 0;
    }
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      const suffixUrl = `report/transactions-history`;
      const urll = `${urlApp.APIURL}api/${suffixUrl}`;
      downloadFile(urll, 'DownloadTransactionStatementFile', 'POST', body);
      return;
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const dudechange = (value, target) => {
    if (target == 'from') {
      setFromDate(value);
    } else {
      setToDate(value);
    }
  };

  return (
    <Div
      height={'100%'}
      backgroundColor={Ecolors.whiteColor}
      flex={1}
      alignItems="center"
      paddingBottom={40}>
      <Div
        padding={16}
        paddingTop={0}
        flexDirection={'column'}
        justifyContent={'flex-start'}
        flex={1}>
        <Label fontWeight={'700'}>{`transactionscreen.chonquy`}</Label>
        <Dropdown
          multiline={true}
          width={343}
          marginTop={6}
          paddingHorizontal={0}
          initData={listProduct}
          value={product}
          multilanguage={true}
          content={`createordermodal.chonsanpham`}
          isActive={true}
          onChange={setProduct}
        />
        <Label
          fontWeight={'700'}
          marginTop={14}>{`transactionscreen.theothoidiemgiaodich`}</Label>

        <Div
          paddingTop={16}
          paddingBottom={23}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}>
          <DatePicker
            autoFocus={true}
            onSelect={date => dudechange(date, 'from')} //when day is clicked
            onChange={date => dudechange(date, 'from')} //only when value has changed
            locale={I18nState == 'vi' ? locale : null}
            popperPlacement="bottom-end"
            customInput={
              <Div>
                <ButtonCalendar
                  value={fromDate}
                  onPress={() => {
                    // setIsShowCalendar(true);
                    value.current = 'from';
                  }}
                  title={`transactionscreen.tungay`}
                />
              </Div>
            }
          />
          <Div width={12} />
          <DatePicker
            autoFocus={true}
            onSelect={date => dudechange(date, 'to')} //when day is clicked
            locale={I18nState == 'vi' ? locale : null}
            onChange={date => dudechange(date, 'to')} //only when value has changed
            popperPlacement="bottom-start"
            customInput={
              <Div>
                <ButtonCalendar
                  value={toDate}
                  onPress={() => {
                    // setIsShowCalendar(true);
                    value.current = 'to';
                  }}
                  title={`transactionscreen.toingay`}
                />
              </Div>
            }
          />
        </Div>
      </Div>
      <ButtonBorder
        loading={loading}
        isDisable={!fromDate || !toDate || !product}
        onPress={() => {
          if (loading) {
            return;
          }
          onAccept();
        }}
        title={`transactionscreen.saoke`}
        width={343}
      />
    </Div>
  );
}

export default React.memo(Statement);
